import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.step15.sectionTitle',
    defaultMessage: 'Section 11 - Claim Summary',
  },
  title: {
    id: 'fastCover.step15.title',
    defaultMessage: 'Title',
  },
  firstName: {
    id: 'fastCover.step15.firstName',
    defaultMessage: 'First Name(s)',
  },
  surname: {
    id: 'fastCover.step15.surname',
    defaultMessage: 'Surname',
  },
  dateOfBirth: {
    id: 'fastCover.step15.dateOfBirth',
    defaultMessage: 'Date of Birth',
  },
  address: {
    id: 'fastCover.step15.address',
    defaultMessage: 'Address',
  },
  addressLine1: {
    id: 'fastCover.step15.addressLine1',
    defaultMessage: 'Address Line 1',
  },
  addressLine2: {
    id: 'fastCover.step15.addressLine2',
    defaultMessage: 'Address Line 2',
  },
  city: {
    id: 'fastCover.step15.city',
    defaultMessage: 'City',
  },
  stateProvinceRegion: {
    id: 'fastCover.step15.stateProvinceRegion',
    defaultMessage: 'State / Province / Region',
  },
  postalZipCode: {
    id: 'fastCover.step15.postalZipCode',
    defaultMessage: 'Postal / Zip Code',
  },
  mobile: {
    id: 'fastCover.step15.mobile',
    defaultMessage: 'Phone Number',
  },
  homePhone: {
    id: 'fastCover.step15.homePhone',
    defaultMessage: 'Home Phone Number',
  },
  workPhone: {
    id: 'fastCover.step15.workPhone',
    defaultMessage: 'Work Phone Number',
  },
  email: {
    id: 'fastCover.step15.email',
    defaultMessage: 'Email',
  },
  preferredContactNumberForClaim: {
    id: 'fastCover.step15.preferredContactNumberForClaim',
    defaultMessage: 'Preferred Contact Number for Claim',
  },
  preferredContactForClaim: {
    id: 'fastCover.step15.preferredContactForClaim',
    defaultMessage: 'Preferred Contact for Claim',
  },
  preferredContactEmailForClaim: {
    id: 'fastCover.step15.preferredContactEmailForClaim',
    defaultMessage: 'Preferred Contact Email for Claim',
  },
  occupation: {
    id: 'fastCover.step15.occupation',
    defaultMessage: 'Occupation',
  },
  policyNumber: {
    id: 'fastCover.step15.policyNumber',
    defaultMessage: 'Policy Number',
  },
  dateBookedTrip: {
    id: 'fastCover.step15.dateBookedTrip',
    defaultMessage: 'Date I booked my trip',
  },
  dateScheduledToDepart: {
    id: 'fastCover.step15.dateScheduledToDepart',
    defaultMessage: 'Date I was originally scheduled to depart on my Trip',
  },
  dateOriginallyScheduled: {
    id: 'fastCover.step15.dateOriginallyScheduled',
    defaultMessage: 'Date I was originally scheduled to return home',
  },
  plannedDestination: {
    id: 'fastCover.step15.plannedDestination',
    defaultMessage: 'Planned destination(s)',
  },
  totalAmountPaidInAud: {
    id: 'fastCover.step15.totalAmountPaidInAud',
    defaultMessage:
      'Total amount of pre-paid travel expenses (in Australian dollars)',
  },
  countryRegionCity: {
    id: 'fastCover.step15.countryRegionCity',
    defaultMessage: 'Country, region, city, etc.',
  },
  reasonForTrip: {
    id: 'fastCover.step15.reasonForTrip',
    defaultMessage: 'Reason for Trip',
  },
  holiday: {
    id: 'fastCover.step15.holiday',
    defaultMessage: 'Holiday',
  },
  visitingFamilyOrFriend: {
    id: 'fastCover.step15.visitingFamilyOrFriend',
    defaultMessage: 'Visiting Family or Friends',
  },
  business: {
    id: 'fastCover.step15.business',
    defaultMessage: 'Business',
  },
  other: {
    id: 'fastCover.step15.other',
    defaultMessage: 'Other',
  },
  doYouHaveAnotherOtherInsurance: {
    id: 'fastCover.step15.doYouHaveAnotherOtherInsurance',
    defaultMessage:
      'Do you have any other insurance that would cover all or part of your loss?',
  },
  yes: {
    id: 'fastCover.step15.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.step15.no',
    defaultMessage: 'No',
  },
  exampleHomeContentsInsurance: {
    id: 'fastCover.step15.exampleHomeContentsInsurance',
    defaultMessage:
      'e.g. Home Contents insurance, Private Health Fund, Credit Card',
  },
  wouldYouLikeToGivePermission: {
    id: 'fastCover.step15.wouldYouLikeToGivePermission',
    defaultMessage:
      'Would you like to give permission for a Third Party to manage this claim on your behalf?',
  },
  ifYesPleaseProvideDetails: {
    id: 'fastCover.step15.ifYesPleaseProvideDetails',
    defaultMessage: 'If yes, please provide details',
  },
  thirdPartyAuthority: {
    id: 'fastCover.step15.thirdPartyAuthority',
    defaultMessage: 'Third Party Authority',
  },
  relationshipToYou: {
    id: 'fastCover.step15.relationshipToYou',
    defaultMessage: 'Relationship to you',
  },
  isRequired: {
    id: 'fastCover.step15.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step15/messages.js